import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#050505] border-t border-white/5 mt-40">
      <div className="px-4 md:px-12 lg:px-24 py-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16">
          <div>
            <h3 className="font-['Playfair_Display'] text-2xl mb-6">HAUTE</h3>
            <p className="text-sm text-white/60 leading-relaxed">
              Selección premium de moda de lujo internacional.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] mb-6 font-semibold">Navegación</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/catalog" className="text-sm text-white/60 hover:text-white transition-colors duration-300">Productos</Link>
              <Link to="/brands" className="text-sm text-white/60 hover:text-white transition-colors duration-300">Marcas</Link>
              <Link to="/about" className="text-sm text-white/60 hover:text-white transition-colors duration-300">Nosotros</Link>
              <Link to="/contact" className="text-sm text-white/60 hover:text-white transition-colors duration-300">Contacto</Link>
            </nav>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] mb-6 font-semibold">Información</h4>
            <nav className="flex flex-col gap-3">
              <a href="#" className="text-sm text-white/60 hover:text-white transition-colors duration-300">Envíos</a>
              <a href="#" className="text-sm text-white/60 hover:text-white transition-colors duration-300">Devoluciones</a>
              <a href="#" className="text-sm text-white/60 hover:text-white transition-colors duration-300">Términos</a>
              <a href="#" className="text-sm text-white/60 hover:text-white transition-colors duration-300">Privacidad</a>
            </nav>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] mb-6 font-semibold">Síguenos</h4>
            <div className="flex gap-4">
              <a href="#" data-testid="social-instagram" className="p-3 border border-white/10 hover:border-white/40 rounded-full transition-all duration-300">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" data-testid="social-facebook" className="p-3 border border-white/10 hover:border-white/40 rounded-full transition-all duration-300">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" data-testid="social-twitter" className="p-3 border border-white/10 hover:border-white/40 rounded-full transition-all duration-300">
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 text-center">
          <p className="text-xs text-white/40 tracking-[0.2em] uppercase">
            © 2025 Haute Couture. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
